<template>
  <div id="dashboard-analytics">
    <div class="router-view">
      <div class="vx-row">
        <!-- <div class="vx-col w-full pb-8">
          <div class="vx-card" style="border:2px solid red;">
            <div
              class="vx-card__collapsible-content vs-con-loading__container z-0"
            >
              <div class="vx-card__header">
                <div class="vx-card__title">
                  <h4 style="color:red">Wichtig</h4>
                </div>
              </div>
              <div class="vx-card__body">
                Wir haben das Speicherverhalten beim Bewerber & den Stellen
                überarbeitet. Ihr habt jetzt bei gewissen Fehlern die
                Möglichkeit uns diese per Mail zu melden. Falls ein solcher Fall
                auftritt ist die Fehlermeldung die Ihr am unteren Bildschirmrand
                erhaltet klickbar. <br />
                Sollten euch in den nächsten Tagen Speicherprobleme auffallen,
                meldet euch bitte umgehend per Telefon bei uns.
              </div>
            </div>
          </div>
        </div> -->
        <div class="vx-col w-full sm:w-full md:w-6/12 lg:w-6/12 xl:w-6/12 pb-8">
          <div
            v-if="statsLoaded && $store.getters['user/hasPermission']('bi')"
            class="vx-row"
          >
            <div
              class="vx-col w-full sm:w-full md:w-6/12 lg:w-6/12 xl:w-6/12 pb-8"
            >
              <StatisticsCardLine
                :icon="['fal', 'user-astronaut']"
                :statistic="applicantsTotal"
                statistic-title="Bewerber"
                :chart-data="applicantsChartData"
              />
            </div>

            <div
              class="vx-col w-full sm:w-full md:w-6/12 lg:w-6/12 xl:w-6/12 pb-8"
            >
              <StatisticsCardLine
                :icon="['fal', 'user-astronaut']"
                :statistic="applicationsTotal"
                statistic-title="Bewerbungseingänge"
                :chart-data="applicationsChartData"
              />
            </div>
          </div>

          <div
            class="vx-col w-full sm:w-full md:w-full lg:w-full xl:w-2/4 mb-0"
          >
            <DashboardNewApplicants />
          </div>
        </div>

        <div
          class="vx-col w-full sm:w-full md:w-6/12 lg:w-6/12 xl:w-6/12 h-auto  pb-8"
        >
          <DashboardNewJobs />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardNewJobs from "../../components/dashboard/DashboardNewJobs.vue";
import DashboardNewApplicants from "../../components/dashboard/DashboardNewApplicants.vue";
import StatisticsCardLine from "./cards/StatisticsCardLine";
import gql from "graphql-tag";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  components: {
    DashboardNewJobs,
    DashboardNewApplicants,
    StatisticsCardLine
  },
  data() {
    return {
      statsLoaded: false,
      applicationsTotal: 0,
      applicationsChartData: {
        series: [
          {
            name: "Bewerbungen",
            data: []
          }
        ]
      },
      applicantsTotal: 0,
      applicantsChartData: {
        series: [
          {
            name: "Bewerber",
            data: []
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters({
      userLoaded: "user/loaded"
    })
  },
  watch: {
    userLoaded: {
      immediate: true,
      handler(v) {
        if (v) {
          this.updateStats();
        }
      }
    }
  },
  methods: {
    async updateStats() {
      if (this.$store.getters["user/hasPermission"]("bi")) {
        this.applicantsChartData.series[0].data = await this.fetchStats(
          "APPLICANT"
        );
        this.applicationsChartData.series[0].data = await this.fetchStats(
          "APPLICATION"
        );
        this.applicantsTotal = await this.fetchStats("APPLICANT", false);
        this.applicationsTotal = await this.fetchStats("APPLICATION", false);
        this.statsLoaded = true;
      }
    },
    async fetchStats(model, withTime = true) {
      let chartStart = moment()
        .subtract(7, "days")
        .startOf("day");
      let { data } = await this.$apollo.query({
        query: gql`
          query ApplicantStat($filter: ConsultantStatFilter!) {
            consultantStats(filter: $filter) {
              datapoints {
                interval
                amount
                model
                field
                fieldValue
                time
                groupingValue
              }
            }
          }
        `,
        variables: {
          filter: {
            consultantID: this.$store.getters["user/consultant"].id,
            timeFilter: withTime
              ? {
                  interval: 1440,
                  fromTime: chartStart,
                  months: false
                }
              : undefined,
            metrics: [
              {
                model
              }
            ]
          }
        }
      });

      if (withTime) {
        let result = [];
        for (let i = 0; i < 7; i++) {
          const current = chartStart.add(1, "day");
          let val = 0;
          for (let entry of data.consultantStats.datapoints || []) {
            if (moment(entry.time).isSame(current, "day")) {
              val = entry.amount;
            }
          }

          result.push(val);
        }

        return result;
      }

      if (
        data.consultantStats.datapoints &&
        data.consultantStats.datapoints[0]
      ) {
        return data.consultantStats.datapoints[0].amount;
      }

      return 0;
    }
  }
};
</script>
